'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { AutorizacaoArEnvio } from '@/types/arbitral/envioArTypes';
import { AutorizacaoArCard } from './AutorizacaoArCard';
import { CorrigirEnderecoArDialog } from './CorrigirEnderecoArDialog';
import { RecusarEnvioArDialog } from './RecusarEnvioArDialog';
interface AutorizacaoArBlocoProps {
  envio: AutorizacaoArEnvio;
  /**
   * Do SERVIDOR, que calcula pelo dia civil de São Paulo. O front não recalcula: o
   * prazo é uma data de calendário e `Date.now()` é um instante, e comparar os dois
   * aqui deixava o card vermelho às 21h da véspera.
   */
  vencida: boolean;
  popupBloqueado: boolean;
  /** Decisão desta solicitação já no ar — trava os botões DELA, não os do vizinho. */
  acaoEmVoo: boolean;
  onAutorizarConvenio: () => void;
  onPagar: () => void;
  onConfirmarPagamento: () => void;
  onVoltar: () => void;
  onDevolverEndereco: (observacao: string) => void;
  onRecusar: (motivo: string) => void;
  onDesfazerRecusa: () => void;
}
export function AutorizacaoArBloco(t0) {
  const $ = _c(30);
  const {
    envio,
    vencida,
    popupBloqueado,
    acaoEmVoo,
    onAutorizarConvenio,
    onPagar,
    onConfirmarPagamento,
    onVoltar,
    onDevolverEndereco,
    onRecusar,
    onDesfazerRecusa
  } = t0;
  const [corrigirAberto, setCorrigirAberto] = useState(false);
  const [recusarAberto, setRecusarAberto] = useState(false);
  let t1;
  if ($[0] !== onDevolverEndereco) {
    t1 = observacao => {
      setCorrigirAberto(false);
      onDevolverEndereco(observacao);
    };
    $[0] = onDevolverEndereco;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDevolver = t1;
  let t2;
  if ($[2] !== onRecusar) {
    t2 = motivo => {
      setRecusarAberto(false);
      onRecusar(motivo);
    };
    $[2] = onRecusar;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleRecusar = t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setCorrigirAberto(true);
    t4 = () => setRecusarAberto(true);
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== acaoEmVoo || $[7] !== envio || $[8] !== onAutorizarConvenio || $[9] !== onConfirmarPagamento || $[10] !== onDesfazerRecusa || $[11] !== onPagar || $[12] !== onVoltar || $[13] !== popupBloqueado || $[14] !== vencida) {
    t5 = <AutorizacaoArCard envio={envio} vencido={vencida} popupBloqueado={popupBloqueado} acaoEmVoo={acaoEmVoo} onAutorizarConvenio={onAutorizarConvenio} onPagar={onPagar} onConfirmarPagamento={onConfirmarPagamento} onVoltar={onVoltar} onCorrigirEndereco={t3} onRecusar={t4} onDesfazerRecusa={onDesfazerRecusa} />;
    $[6] = acaoEmVoo;
    $[7] = envio;
    $[8] = onAutorizarConvenio;
    $[9] = onConfirmarPagamento;
    $[10] = onDesfazerRecusa;
    $[11] = onPagar;
    $[12] = onVoltar;
    $[13] = popupBloqueado;
    $[14] = vencida;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setCorrigirAberto(false);
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== corrigirAberto || $[18] !== envio.endereco || $[19] !== handleDevolver) {
    t7 = <CorrigirEnderecoArDialog aberto={corrigirAberto} endereco={envio.endereco} onFechar={t6} onDevolver={handleDevolver} />;
    $[17] = corrigirAberto;
    $[18] = envio.endereco;
    $[19] = handleDevolver;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setRecusarAberto(false);
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== envio.requeridoNome || $[23] !== handleRecusar || $[24] !== recusarAberto) {
    t9 = <RecusarEnvioArDialog aberto={recusarAberto} requeridoNome={envio.requeridoNome} onFechar={t8} onRecusar={handleRecusar} />;
    $[22] = envio.requeridoNome;
    $[23] = handleRecusar;
    $[24] = recusarAberto;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t7 || $[28] !== t9) {
    t10 = <>{t5}{t7}{t9}</>;
    $[26] = t5;
    $[27] = t7;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}